<template>
    <div class="flex-col" :class="[{'order-last': position === 'right'}, {'right-sidebar': position === 'right'}, {'left-sidebar': position === 'left'}, {'order-first': position === 'left'}]">
        <slot>
            <div class="font-robotoMedium text-lg pb-4 pt-8 border-b-2 border-themeGray">{{getTitleMessage()}}</div>
            <PostsList />
<!--            <SubscribeForm />-->
            <Banner v-if="getTitleMessage() == 'Самое популярное'" :img-path="banner.IMG_SRC" :url-path="banner.URL" class="mt-10"/>
        </slot>
    </div>
</template>

<script>
import PostsList from "./PostsList.vue";
// import SubscribeForm from "./SubscribeForm.vue";
import Banner from "./Banner.vue";
  export default {
    name: "SidebarWidget",
    props: {
      position: String
    },
    components: {
      PostsList,
      // SubscribeForm,
      Banner
    },
    data() {
      return {
        banner: {}
      }
    },
    methods: {
      getTitleMessage() {
        return this.$store.getters.getTranslation("most_popular");
      },
      getBanner() {
        this.banner = this.$store.getters.getBanner;
      }
    },
    mounted() {
      this.getBanner();
    }
  }
</script>

<style scoped>
    .right-sidebar {
        padding-left: 2.5em;
        width: 39%;
    }

    .left-sidebar {
        padding-right: 2.5em;
        width: 39%;
    }


    @media only screen and (min-width: 1920px) {
        .right-sidebar {
            padding-left: 4.5em;
        }
        .left-sidebar {
            padding-right: 4.5em;
        }
    }
</style>
